module.exports = __webpack_public_path__ + "letterFadePositionInLeft.gif";